import { useEffect, useState } from "react";
import { getTransactionsOverTime } from "../_util/TransactionUtilities";
import TransactionController from "../controllers/TransactionController";
import { usePlan } from "../_providers/PlanProvider";
import Transaction from "../models/Transaction";
import TransactionComponent from "../_components/Transaction";

const FuturePage = () => {
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const {selectedPlan} = usePlan();

    const reloadTransactions = () => {
        if (!selectedPlan) {
            console.error("No plan selected");
            return;
        }
        TransactionController.getTransactions(selectedPlan?.uid).then((transactions) => {
            const startDate = new Date();
            const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 14);
            const transactionsOverTime = getTransactionsOverTime(transactions, startDate, endDate);
            const sortedTransactions = transactionsOverTime.sort((a, b) => a.date.toMillis() - b.date.toMillis());
            setTransactions(sortedTransactions);
        });
    }

    useEffect(() => {
        reloadTransactions();
    }, [selectedPlan]);
    let prevDate = new Date();
    prevDate.setDate(prevDate.getDate() - 1);
    return (
        <div style={{paddingBottom: "100px"}}>
            <h1>Future Page</h1>
            {transactions.map((transaction) => {
                if(prevDate.getDate() !== transaction.date.toDate().getDate()) {
                    prevDate = transaction.date.toDate();
                    return <>
                        <p><b key={transaction.date.toMillis()}>{transaction.date.toDate().toLocaleDateString("nl-NL", {weekday: "long", day: "numeric", month: "long", year: "numeric"})}</b></p>
                        <TransactionComponent key={transaction.uid} item={transaction}/>
                    </>;
                }
                return <TransactionComponent key={transaction.uid} item={transaction}/>;

            })}
        </div>
    );
}
export default FuturePage;